import React, { useState } from 'react';
import { Menu, MenuButton, MenuList, MenuItemOption, MenuOptionGroup, Button } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faPlane } from '@fortawesome/pro-regular-svg-icons';
import { Span } from 'shared-components';

interface IProps {
  immigrationProviders: string[];
  selectedValue: string | null;
  onDelete: () => void;
  onChange: (provider: string) => void;
}

interface IOption {
  value: string;
  label: string;
}

const NO_PROVIDER = 'none';

export const ImmigrationProvider = (props: IProps) => {
  const { immigrationProviders, selectedValue, onDelete, onChange } = props;

  const [selectedImmigrationProvider, setSelectedImmigrationProvider] = useState(selectedValue ?? NO_PROVIDER);

  const dropDownOptions: IOption[] = [
    { label: 'None', value: NO_PROVIDER },
    ...(immigrationProviders.length
      ? immigrationProviders.map(provider => {
          return { label: provider, value: provider };
        })
      : []),
  ];

  const handleImmigrationProviderChange = (evt: React.FormEvent<HTMLButtonElement>) => {
    setSelectedImmigrationProvider(evt.currentTarget.value);
    if (evt.currentTarget.value === NO_PROVIDER && selectedValue) {
      onDelete();
    } else {
      onChange(evt.currentTarget.value);
    }
  };

  return (
    <>
      <Menu closeOnSelect>
        <MenuButton
          key="select-immigration-provider"
          data-selector={'select-immigration-provider'}
          as={Button}
          variant={'ghost'}
          size={'sm'}
          leftIcon={<FontAwesomeIcon icon={faPlane} className="utility-icon" fixedWidth />}
          rightIcon={<FontAwesomeIcon icon={faAngleDown} className="utility-icon" />}
          textAlign={'left'}
          py={2}
          height={'auto'}
          lineHeight={4}
        >
          Change immigration provider
          <Span data-selector="selected-immigration-provider" display={'block'} fontSize={'xs'} color={'muted'} mt={1}>
            {selectedImmigrationProvider}
          </Span>
        </MenuButton>

        <MenuList>
          <MenuOptionGroup defaultValue={selectedImmigrationProvider} type="radio">
            {dropDownOptions.map((item, index) => (
              <MenuItemOption
                data-selector={`immigration-provider-${item.value}`}
                key={index}
                value={item.value}
                onClick={(evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleImmigrationProviderChange(evt)}
              >
                {item.label}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </>
  );
};
